export const arrowDown = {
	className: 'icon-arrow-down',
	viewBox: '0 0 128.96201 76.267001',
	paths: ['m 128.962,0 0,35.711 -13.914,8.763 L 80.333,66.315 64.483,76.267 48.635,66.315 13.92,44.474 0,35.711 0,0 64.482,41.006 128.962,0 Z']
}
